export default "__VITE_PUBLIC_ASSET__07268c49__"